export default __webpack_public_path__ + "static/media/Lucida-Sans-Unicode-Regular.a1cfd222.ttf";